import { API_BASE_URL } from '../constants/api';

export const forgotPassword = async (email) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Une erreur est survenue');
  return data;
};

export const verifyResetCode = async (email, code) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/verify-reset-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Une erreur est survenue');
  return data; // { reset_token }
};

export const resetPassword = async (resetToken, newPassword, confirmPassword) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      reset_token: resetToken,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Une erreur est survenue');
  return data;
};
